import WalletBalanceItem from "./WalletBalanceItem";

export default WalletBalanceItem;